import Swal from 'sweetalert2'
import {
    IS_LOADING_POINT_PACKAGES,
    LIST_OF_POINT_PACKAGES} from './types'

import {
    urlServer
} from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})


export const seePointPackages = () => async dispatch => {
    dispatch({
        type: IS_LOADING_POINT_PACKAGES
    });

    await fetch(`${urlServer}adminpointpackages/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: LIST_OF_POINT_PACKAGES,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}
